import React from 'react';
import { SEVERITY_SCALE } from '../../../../constants/journey';

// Hand-written faces rather than an icon set or Unicode emoji: the design wants
// a filled disc, which outline icons cannot give, and Unicode renders
// differently on every OS with colours we cannot set.
//
// Only the mouth changes shape across the five; the disc colour carries the
// rest of the signal, which is what stays readable at calendar-cell size.
const MOUTHS = {
	1: 'M7.5 14 Q12 19 16.5 14',
	2: 'M7.5 14.8 Q12 17.6 16.5 14.8',
	3: 'M7.6 15.4 L16.4 15.4',
	4: 'M7.5 17.2 Q12 14.4 16.5 17.2',
	5: 'M7.5 18 Q12 13.2 16.5 18',
};

const INK = '#1F2937';

const SeverityFace = ({ rating, size = 28, className, showTitle = true }) => {
	const level = SEVERITY_SCALE[rating];
	if (!level) return null;

	const label = `${level.label} (${rating} of 5)`;

	return (
		<svg
			className={className}
			width={size}
			height={size}
			viewBox='0 0 24 24'
			role='img'
			aria-label={label}
			focusable='false'
		>
			{showTitle && <title>{label}</title>}
			<circle cx='12' cy='12' r='11' fill={level.color} />
			<circle cx='8.6' cy='9.6' r='1.35' fill={INK} />
			<circle cx='15.4' cy='9.6' r='1.35' fill={INK} />
			<path
				d={MOUTHS[rating]}
				fill='none'
				stroke={INK}
				strokeWidth='1.6'
				strokeLinecap='round'
			/>
		</svg>
	);
};

export default SeverityFace;
